import { render, staticRenderFns } from "./VerticalMenuItem.vue?vue&type=template&id=6f7fe6d0&"
import script from "./VerticalMenuItem.js?vue&type=script&lang=js&"
export * from "./VerticalMenuItem.js?vue&type=script&lang=js&"
import style0 from "./VerticalMenuItem.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports